import { get } from 'lodash';
import * as React from 'react';
import { reduxForm } from 'redux-form';
import { Card } from 'material-ui/Card';
import { compose, withHandlers, withProps } from 'recompose';

import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import Button from '@inqool/uas-web-core/es/components/controls/Button';

import { entityDetailEnhancer } from '@components/hoc/entityDetailEnhancer';
import { Tabs } from '@components/tabs';

import { getDelict, syncPayment } from '@modules/delicts/_delictsActions';
import * as T from '@modules/delicts/_delictsTypes';

import { DelictsFormBasic } from '@modules/delicts/DelictsFormBasic';
import { DelictsFormAddress } from '@modules/delicts/DelictsFormAddress';
import { DelictsFormPayment } from '@modules/delicts/DelictsFormPayment';
import { DelictsFormClamp } from '@modules/delicts/DelictsFormClamp';
import { withNotifications } from '@components/hoc/withNotifications';

const enhance = compose<T.DelictsFormProps, T.Outter & T.DelictsFormProps>(
  entityDetailEnhancer<T.DelictEnhancerProps<T.Delict>, T.Delict>({
    getEntity: getDelict,
    defaultEntity: {}
  }),
  breadcrumbs(({ entity }) => [
    { label: 'Přestupky', to: '/delicts' },
    { label: get(entity, 'number', 'Nepřiřazené číslo') }
  ]),
  withProps<{}, T.DelictProps>(({ entity }) => ({
    initialValues: {
      ...entity
    },
    noticeOfficer: !!get(entity, 'noticeOfficer'),
    entity,
    syncUnavailable:
      !get(entity, 'offender') ||
      get(entity, 'state') !== 'SOLVED' ||
      (get(entity, 'resolution') !== 'BNP' && get(entity, 'resolution') !== 'BNZ')
  })),
  withNotifications({ syncPayment }),
  withHandlers({
    syncPaymentInVera: ({ syncPaymentNotify, entity }) => async () => {
      await syncPaymentNotify(get(entity, 'fine.id'));
    }
  }),
  reduxForm({
    form: 'module-delicts'
  })
);

export const View: React.SFC<
  T.DelictsFormProps &
    T.Outter & {
      noticeOfficer: boolean;
      entity: T.Delict;
      syncUnavailable: boolean;
      syncPaymentInVera?: () => Promise<void>;
    }
> = ({ closeItem, noticeOfficer, entity, syncUnavailable, syncPaymentInVera }) => (
  <div>
    <form className="layout">
      <Card>
        <Tabs
          lazy={true}
          items={[
            { label: 'Základní', style: { minWidth: 175 }, content: <DelictsFormBasic /> },
            { label: 'Adresa a popis', style: { minWidth: 175 }, content: <DelictsFormAddress /> },
            {
              label: 'Platba a BNP',
              style: { minWidth: 175 },
              content: <DelictsFormPayment delict={entity} />
            },
            {
              label: 'Botička a odtah/vyrozumění',
              style: { minWidth: 175 },
              content: <DelictsFormClamp noticeOfficer={noticeOfficer} />
            }
          ]}
        />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
        <Button
          label="Synchronizovat platbu"
          style={{ margin: '16px 0 16px 16px' }}
          onClick={syncPaymentInVera}
          disabled={syncUnavailable}
        />
      </Card>
    </form>
  </div>
);

export const DelictsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/delicts/DelictsForm.tsx